import {i18n} from '@netx/core/i18n';

export default {
	saveSuccess: i18n.t('i18n.success'),
	singleFieldMultipleFieldsSelected: i18n.t(
		'i18n.multipleColumnsAreSelectedUseSidebar',
	),
	singleFieldNoFieldsSelected: i18n.t(
		'i18n.selectWithinASingleColumnToEnableEdit',
	),
};
